import Swiper, { Lazy, Navigation, Pagination } from 'swiper';

export default class FeaturedStories {
	constructor () {
		this.init();
	}

	init () {
		if(document.querySelector('.swiper-stories')) {
			Swiper.use([Navigation, Pagination, Lazy]);
			new Swiper('.swiper-stories', {
				slidesPerView: 1,
				preloadImages: false,
				spaceBetween: 0,
				pagination: {
					el: '.swiper-stories .swiper-pagination',
					clickable: true
				},
				lazy: {
					loadPrevNext: false,
					loadOnTransitionStart: true,
				}
			});
		}
	}
}
